import BackgroundJob from './BackgroundJob';

class ConsoleLogBackgroundJob extends BackgroundJob {
  _run(args, di) {
   // console.log(args);
  }
}

export default ConsoleLogBackgroundJob;
